<template>
    <b-row no-gutters>
        <b-col class="px-4 py-3">
            <h4 class="pb-2">
                Add-Ons
            </h4>
            <template v-for="(value, valueIndex) in values">
                <div v-if="origin==='new_product'" :key="valueIndex">
                  <h5 class="mb-3" style="font-family: MainFontBold, sans-serif; font-size: 18px; color: #2a2a2a;">{{ value.name }}</h5>
                  <section class="py-4 mb-4" v-for="(variation, index) in value.variations" :key="index">
                      <div
                          v-b-toggle="'product-collapse' + valueIndex + index" 
                          class="border-bottom px-4" 
                          id="collapse-container"
                      >
                          <h5 class="variable" style="position: relative; top: -6px;">
                              {{ variation.name }}
                          </h5>
                          <img
                              src="@/assets/images/icons/collapse.svg"
                              alt="Collapsed Icon"
                              class="d-inline-block mr-3 when-closed"
                              style="width: 14px; height: 14px;"
                          />
                          <img
                              src="@/assets/images/icons/expand.svg"
                              alt="Expand Icon"
                              class="d-inline-block mr-3 when-opened"
                              style="width: 14px; height: 14px;"
                          />
                      </div>
                      <b-collapse :id="'product-collapse' + valueIndex + index" visible class="py-0 px-4 pt-3">
                          <b-row>
                              <b-col cols="2">
                                  <switches 
                                      v-model="variation.visibility"
                                      theme="custom"
                                      color="primary"
                                      type-bold="true"
                                      label="Visibility"
                                      id="sale_switch">
                                  </switches>
                              </b-col>
                              <b-col cols="2" class="pl-2">
                                  <switches 
                                      v-model="variation.is_free"
                                      theme="custom"
                                      color="primary"
                                      type-bold="true"
                                      label="Free"
                                      id="sale_switch">
                                  </switches>
                              </b-col>
                          </b-row>
                          <b-row>
                              <b-col cols="3" v-if="!variation.is_free">
                                  <div id="regular-price-container">
                                      <b-form-group
                                          id="currencyGroup"
                                          label="Regular Price"
                                          label-for="currency"
                                          class="secondary-label">
                                          <b-input-group>
                                              <b-form-select
                                                  slot="prepend"
                                                  :options="options.currency"
                                                  v-model="variation.currency">
                                              </b-form-select>
                                              <b-form-input 
                                                  id="regularPrice"
                                                  v-model="variation.price"
                                                  required
                                                  type="number"
                                                  min="1"
                                                  max="10000000000"
                                                  oninput="this.value = Math.abs(this.value)" />
                                          </b-input-group>
                                      </b-form-group>
                                  </div>
                              </b-col>
                              <b-col cols="3">
                                  <b-form-group
                                      id="skuGroup"
                                      label="SKU"
                                      label-for="sku"
                                      class="secondary-label mb-2"
                                      :invalid-feedback="errorMessage('add_ons.' + valueIndex + '.items.' + index + '.sku')"
                                      :state="isValid('add_ons.' + valueIndex + '.items.' + index + '.sku')">
                                      <b-form-input
                                          :id="'sku' + index"
                                          type="text"
                                          v-model="variation.sku"
                                          required
                                          :formatter="skuFormatter"
                                      >
                                      </b-form-input>
                                  </b-form-group>
                              </b-col>
                          </b-row>
                      </b-collapse>
                  </section>
                </div>
            </template>
            <!-- Edit Add-Ons -->
            <template v-for="(value, valueIndex) in values">
                <div v-if="origin==='edit_product'" :key="valueIndex">
                  <h5 v-if="value.name != ''" class="mb-3" style="font-family: MainFontBold, sans-serif; font-size: 18px; color: #2a2a2a;">{{ value.name }}</h5>
                  <template v-for="(variation, index) in value.add_ons">
                    <section 
                      v-if="value.name != '' && (variation.uuid != null || generatedAdOns)" 
                      class="py-4 mb-4"
                      :key="index"
                    >
                      <div
                          class="border-bottom px-4" 
                          id="collapse-container"
                      >
                          <h5 class="variable" style="position: relative; top: -6px;">
                              {{ variation.name }}
                          </h5>
                          <div class="buttons-container d-inline-flex align-items-center mb-3">
                              <img
                                  src="@/assets/images/actions/delete.svg"
                                  alt="Delete Button"
                                  class="mr-2 cursor-pointer"
                                  @click="handleDeleteAddOn({ attribute: valueIndex, variation: index })"
                              />
                              <img
                                  src="@/assets/images/icons/collapse.svg"
                                  alt="Collapsed Icon"
                                  class="d-none mr-3 cursor-pointer"
                                  style="width: 14px; height: 14px;"
                                  @click.self="$root.$emit('bv::toggle::collapse', `addon-collapse-${valueIndex}-${index}`)"
                                  :ref="`addon-collapse-to-open-${valueIndex}-${index}`"
                              />
                              <img
                                  src="@/assets/images/icons/expand.svg"
                                  alt="Expand Icon"
                                  class="d-inline-block mr-3 cursor-pointer"
                                  style="width: 14px; height: 14px;"
                                  @click.self="$root.$emit('bv::toggle::collapse', `addon-collapse-${valueIndex}-${index}`)"
                                  :ref="`addon-collapse-to-close-${valueIndex}-${index}`"
                              />
                          </div>
                      </div>
                      <b-collapse :id="`addon-collapse-${valueIndex}-${index}`" visible class="py-0 px-4 pt-3">
                          <b-row>
                              <b-col cols="2">
                                  <switches 
                                      v-model="variation.visibility"
                                      theme="custom"
                                      color="primary"
                                      type-bold="true"
                                      label="Visibility"
                                      id="sale_switch">
                                  </switches>
                              </b-col>
                              <b-col cols="2" class="pl-2">
                                  <switches 
                                      v-model="variation.is_free"
                                      theme="custom"
                                      color="primary"
                                      type-bold="true"
                                      label="Free"
                                      id="sale_switch">
                                  </switches>
                              </b-col>
                          </b-row>
                          <b-row>
                              <b-col cols="3" v-if="!variation.is_free">
                                  <div id="regular-price-container">
                                      <b-form-group
                                          id="currencyGroup"
                                          label="Regular Price"
                                          label-for="currency"
                                          class="secondary-label">
                                          <b-input-group>
                                              <b-form-select
                                                  slot="prepend"
                                                  :options="options.currency"
                                                  v-model="variation.currency">
                                              </b-form-select>
                                              <b-form-input 
                                                  id="regularPrice"
                                                  v-model="variation.price"
                                                  required
                                                  type="number"
                                                  min="1"
                                                  max="10000000000"
                                                  oninput="this.value = Math.abs(this.value)" />
                                          </b-input-group>
                                      </b-form-group>
                                  </div>
                              </b-col>
                              <b-col cols="3">
                                  <b-form-group
                                      id="skuGroup"
                                      label="SKU"
                                      label-for="sku"
                                      class="secondary-label mb-2"
                                      :invalid-feedback="errorMessage('add_ons.' + valueIndex + '.items.' + index + '.sku')"
                                      :state="isValid('add_ons.' + valueIndex + '.items.' + index + '.sku')">
                                      <b-form-input
                                          :id="'sku' + index"
                                          type="text"
                                          v-model="variation.sku"
                                          required
                                          :formatter="skuFormatter"
                                      >
                                      </b-form-input>
                                  </b-form-group>
                              </b-col>
                          </b-row>
                      </b-collapse>
                    </section>
                  </template>
                </div>
            </template>
        </b-col>
    </b-row>
</template>

<script>
import { mapState } from "vuex";

import Switches from "vue-switches";
import Datepicker from "vue-bulma-datepicker";

export default {
    name: "ProductVariables",
    props: [
        "values",
        "discount",
        "sale",
        "origin",
        "variation_names",
        "payment",
        "basic_details",
        "generatedAdOns"
    ],
    components: {
        Switches,
        Datepicker
    },
    data() {
        return {
            fields: [
                {
                    key: "variation"
                },
                // {
                //     key: "stock",
                //     thStyle: {
                //         "min-width": "150px"
                //     }
                // },
                {
                    key: "regular_price"
                },
                {
                    key: "sku",
                    label: "SKU"
                }
                // {
                //     key: "on_sale",
                //     label: "Item on Sale"
                // },
                // {
                //     key: "visibility"
                // }
            ],
            options: {
                currency: [{ value: "PHP", text: "PHP" }],
                discount: [
                    { value: "%", text: "%" },
                    { value: "PHP", text: "PHP" }
                ]
            }
        };
    },
    mounted() {
        this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
            this.$nextTick(() => {
                if (this.origin == 'new_product') {
                    const get_index = collapseId.includes('addon-collapse')
                        ? collapseId.split('-').pop()
                        : null;
                    if (isJustShown) {
                        if (this.$refs[`addon-collapse-to-open-${get_index}`]) {
                            this.$refs[`addon-collapse-to-open-${get_index}`][0].classList.add('d-none');
                            this.$refs[`addon-collapse-to-open-${get_index}`][0].classList.remove('d-inline-block');

                            this.$refs[`addon-collapse-to-close-${get_index}`][0].classList.add('d-inline-block');
                            this.$refs[`addon-collapse-to-close-${get_index}`][0].classList.remove('d-none');
                        }
                    } else {
                        if (this.$refs[`addon-collapse-to-open-${get_index}`]) {
                            this.$refs[`addon-collapse-to-close-${get_index}`][0].classList.add('d-none');
                            this.$refs[`addon-collapse-to-close-${get_index}`][0].classList.remove('d-inline-block');

                            this.$refs[`addon-collapse-to-open-${get_index}`][0].classList.add('d-inline-block');
                            this.$refs[`addon-collapse-to-open-${get_index}`][0].classList.remove('d-none');
                        }
                    }
                }
            });
        });
    },
    computed: {
        ...mapState("estoreInventories", ["loading", "errors", "product_data"]),
        ...mapState("estoreLocations", ["editingFromLocationsPage"]),
        dateRangeConfig: {
            get: function() {
                return {
                    altInput: true,
                    altFormat: "M j, Y",
                    dateFormat: "Y-m-d",
                    static: true,
                    mode: "range",
                    // minDate: "today",
                    defaultDate: ["today", "today"]
                };
            }
        }
    },
    methods: {
        skuFormatter: function(value, event) {
            return event === null ? value : value.replace(/[^\w-]/gi, "");
        },
        errorMessage: function(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors[field];
        },
        isValid: function(field) {
            if (this.errors == null) {
                return false;
            }

            return this.errors[field] ? false : true;
        },
        discountFormatter: function(value, event) {
            if (event === null) {
                return value;
            }

            if (this.discount.discount_type === "%") {
                if (Number(value) > 99) {
                    return 99;
                }
            }
            return value;
        },
        setDiscount: function(obj) {
            this.$parent.$parent.$parent.setDiscount(obj);
        },
        inDiscountChecker: function(index) {
            this.$parent.$parent.$parent.inDiscountChecker(index);
        },
        inSaleChecker: function(index) {
            this.$parent.$parent.$parent.inSaleChecker(index);
        },
        transformVariationName: function(code) {
            let store_code = code.split("_").map(code => {
                return code.split("-")[0];
            });

            let attributes = this.product_data.attributes;
            let variations = store_code
                .map((code, index) => {
                    return attributes[index].variations
                        .map(item => item)
                        .filter(item => item.hash.split("-")[0] == code);
                })
                .map(variant => {
                    return variant[0].name;
                });
            return variations.join(" - ");
        },
        handleDeleteAddOn(param) {
            const add_ons_length = this.values[param.attribute].add_ons.length;
            if (add_ons_length <= 1) this.$emit("deleteAttributeAdOnEdit", param.attribute);
            else this.$emit("deleteVariationAdOnEdit", param);
        }
    }
};
</script>

<style lang="scss" scoped>
#collapse-container {
    cursor: pointer;
    display: flex;

    .variable {
        flex: 1;
    }
    // Changed
}
</style>
